/* 🤖 this file was generated by svg-to-ts */
export const DfIconAward16: {
  name: 'award-16';
  data: string;
} = {
  name: 'award-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7 9.356V8H5a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9v1.356l.297.636a.578.578 0 0 0 .436.328l1.777.273a.58.58 0 0 1 .326.98l-1.322 1.361a.583.583 0 0 0-.157.5l.307 1.892a.58.58 0 0 1-.85.601l-1.535-.853a.575.575 0 0 0-.558 0l-1.536.853a.576.576 0 0 1-.85-.601l.308-1.893a.583.583 0 0 0-.157-.499l-1.322-1.362a.583.583 0 0 1 .326-.98l1.777-.272a.578.578 0 0 0 .436-.328z" fill-rule="evenodd"/></svg>`
};
